import React, { useEffect, useState, useRef } from "react";
import { array, string, object, func } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { throttle } from "lodash";

import { Facebook, Instagram, InstagramOriginal, Pinterest, X } from "./../../atoms/icons/StoryPageIcons";
import YoutubeIcon from "../footer/FooterIcons/YoutubeIcon";
import HamburgerIcon from "../../atoms/icons/hamburger";
import SearchIcon from "../../atoms/icons/search-icon";
import NavbarSearch from "./NavbarSearch";
import VerticalMenubar from "../header/VerticalMenubar";
import { MenuItem } from "./helper-components";
import { CloseIcon } from "../../basic/icons/close-icon";
import Headroom from "./UniformHeader/Headroomindex";

import { STATIC_PAGE_LINKS } from "../../../../isomorphic/constants";
import { staticTexts } from "../../utils/Translate";

import "./header.m.css";

const HeaderView = ({ headerMenuItems, pageType, section, hamburgerMenuItems, publisherAttributes, headerDown }) => {
  const [isVerticalMenubar, setVerticalMenuBar] = useState(false);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [isMobile, setIsMobile] = useState();
  const ref = useRef(null);

  useEffect(() => {
    const anchorAd = document.getElementById("anchor-ad-container") || "";

    if (anchorAd) {
      isVerticalMenubar ? (anchorAd.style.display = "none") : (anchorAd.style.display = "block");
    }
  }, [isVerticalMenubar]);

  useEffect(() => {
    setIsMobile(global.deviceWidth < 876);
    window.addEventListener("scroll", throttle(handleScroll, 50));
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    isVerticalMenubar
      ? (global.document.body.style.cssText = `overflow: hidden; ${
          isMobile ? "padding-right: 0;" : "padding-right: 15px;"
        }  width: 100%; max-height: 100vh`)
      : (global.document.body.style.cssText = "overflow-x: hidden, overflow-y: auto");
  }, [isVerticalMenubar]);

  useEffect(() => {
    if (pageType === "search-page" && isSearchClicked) {
      setIsSearchClicked(!isSearchClicked);
    }
  }, [pageType]);

  const topAdHeight = 120;

  const handleScroll = () => {
    const headerEle = document.getElementById("header");
    const navbarTopDistance = Math.abs(window.pageYOffset || document.documentElement.scrollTop);
    navbarTopDistance < 107 + topAdHeight ? headerEle.classList.remove("sticky") : headerEle.classList.add("sticky");
  };

  const onSearchClick = () => setIsSearchClicked(!isSearchClicked);
  const toggleVerticalMenubar = () => setVerticalMenuBar(!isVerticalMenubar);

  const onUnPin = () => {
    headerDown(false);
  };

  const onUnfix = () => {
    headerDown(true);
  };

  const onPin = () => {
    headerDown(true);
  };

  return (
    <Headroom onPin={onPin} onUnpin={onUnPin} onUnfix={onUnfix}>
      <div styleName="wrapper" className="header-wrapper">
        {isMobile !== undefined && isMobile && (
          <div styleName="row-1" className="row-1">
            <Link aria-label="haalfashion logo" href="/" styleName="logo-icon">
              <img src="/haalfashion.svg" alt="হাল ফ্যাশন" onClick={() => setVerticalMenuBar(false)} />
            </Link>
            <div styleName="right-side-wrapper">
              {isVerticalMenubar ? (
                <div styleName="close" onClick={toggleVerticalMenubar}>
                  <CloseIcon color="#000" width={32} height={32} />
                </div>
              ) : (
                <>
                  <Link aria-label="search icon" href="/search">
                    <div styleName="search-icon">
                      <SearchIcon color="#DAA520" width={28} height={28} />
                    </div>
                  </Link>
                  <div styleName="hamburger-icon" onClick={toggleVerticalMenubar}>
                    <HamburgerIcon />
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {isMobile !== undefined && !isMobile && (
          <>
            {!isVerticalMenubar && (
              <div styleName="row-0">
                <div styleName="social-wrapper">
                  <span>{staticTexts().followUS}</span>
                  <div styleName="social-icons">
                    <Link
                      aria-label="facebook icon"
                      href={STATIC_PAGE_LINKS.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Facebook width={24} height={24} />
                      <Facebook color="#1877F2" width={24} height={24} />
                    </Link>
                    <Link
                      aria-label="youtube icon"
                      href={STATIC_PAGE_LINKS.youtube}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <YoutubeIcon width={24} height={24} />
                      <YoutubeIcon color="#FF0000" width={24} height={24} />
                    </Link>
                    <Link
                      aria-label="instagram icon"
                      href={STATIC_PAGE_LINKS.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Instagram width={24} height={24} />
                      <InstagramOriginal width={24} height={24} />
                    </Link>
                    <Link
                      aria-label="twitter icon"
                      href={STATIC_PAGE_LINKS.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <X width={24} height={24} />
                      <X color="#0F1419" width={24} height={24} />
                    </Link>
                    <Link
                      aria-label="pinterest icon"
                      href={STATIC_PAGE_LINKS.pinterest}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Pinterest width={24} height={24} />
                      <Pinterest color="#E60023" width={24} height={24} />
                    </Link>
                  </div>
                </div>
                <div styleName="search-slider" ref={ref}>
                  <NavbarSearch
                    searchClick={onSearchClick}
                    publisherAttributes={publisherAttributes}
                    closeBtn={false}
                  />
                </div>
              </div>
            )}
            <div styleName={`${isVerticalMenubar ? "row1-gap" : ""} row-1`}>
              <div styleName="dummy"></div>
              <Link href="/" styleName="logo-icon">
                <img src="/haalfashion.svg" alt="হাল ফ্যাশন" onClick={() => setVerticalMenuBar(false)} />
              </Link>

              {!isVerticalMenubar ? (
                <div styleName="hamburger-icon" onClick={toggleVerticalMenubar}>
                  <span>মেন্যু</span>
                  <HamburgerIcon />
                </div>
              ) : (
                <div styleName="close-wrapper">
                  <div styleName="close" onClick={toggleVerticalMenubar}>
                    <CloseIcon color="#000" width={32} height={32} />
                  </div>
                </div>
              )}
            </div>

            <div styleName="row-2" className="row-2">
              <ul styleName="menus">
                {headerMenuItems.map((item, index) => (
                  <li key={index} styleName="menu-item">
                    <MenuItem
                      item={item}
                      temClick={toggleVerticalMenubar}
                      dataTagCategory="Menu"
                      isSelected={
                        pageType === "section-page" && section
                          ? section.name === item.title || section["parent-id"] === item["item-id"]
                          : false
                      }
                      isHeaderMenu={true}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}

        {isVerticalMenubar && (
          <VerticalMenubar
            isDesktop={true}
            toggleVerticalMenubar={toggleVerticalMenubar}
            hamburgerMenu={hamburgerMenuItems}
            pageType={pageType}
            section={section}
          />
        )}
      </div>
    </Headroom>
  );
};

HeaderView.propTypes = {
  headerMenuItems: array,
  publisherAttributes: object,
  hamburgerMenuItems: array,
  pageType: string,
  section: object,
  headerDown: func,
};

const mapStateToProps = (state) => ({
  headerMenuItems: get(state, ["qt", "data", "navigationMenu", "headerMenuItems"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  hamburgerMenuItems: get(state, ["qt", "data", "navigationMenu", "hamburgerMenuItems"], []),
  pageType: get(state, ["qt", "pageType"], ""),
  section: get(state, ["qt", "data", "section"], null),
});

const mapDispatchToProps = (dispatch) => ({
  headerDown: (flag) => dispatch({ type: "HEADER_DOWN", payload: flag }),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderView);
